export default __webpack_public_path__ + "static/media/Banner 1.f3ec0d72.jpg";